export const sortAlphabetically = (list: any) => {
	return list.toSorted((a: any, b: any) => {
		if (a.label === b.label) {
			return 0
		}
		if (a.label > b.label) {
			return 1
		} else {
			return -1
		}
	})
}
